<template>
  <div class="mj_page flex jb">
    <div class="left_area">
      <div class="left_top">
        <div class="scrollable-content">
          <div class="toolsIntroduce">

            <div class="right">
              <div>
                图像擦除
              </div>
              <span>
                一键消除画面上不需要的元素
              </span>
            </div>
          </div>
          <div class="describe">
<!--            <div class="refer_title" @click="openRemoval()">-->
<!--              <div></div>-->
<!--              打开弹窗-->
<!--            </div>-->
            <div class="refer_title">
              <div></div>
              上传图片（必填）
            </div>
            <div class="Reference_image" v-loading="upImgloading"
                 element-loading-background="rgba(122, 122, 122, 0.8)">
              <el-upload
                  ref="elUpload"
                  class="upload-demo"
                  drag
                  :action="fileApi+'/api/front/upload/?fdir=mj_tool'"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  accept="image/jpeg, image/png, image/bmp, image/webp"
                  multiple>
                <div v-if="form.iw_url" class="yesUpload">
                  <img :src="form.iw_url" alt="" class="yesUpload_img" ref="originImg">
                  <img :src="form.iw_urls" class="yesUploadMask" v-show="clearMaskShow" alt="">
                  <!-- <canvas class="yesUploadMask" v-show="clearMaskShow" ref="yesMask"></canvas> -->
                  <div class="yesUpload_icon" @click.stop="openRemovalOther()">
                    重新绘制
                  </div>
                </div>
                <div v-else class="noUpload">
                  <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                  <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                  <div> 只能上传jpg/png文件，且不超过5MB</div>
                </div>
              </el-upload>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <popup v-show="isDrowShow" ref="imgRemovalPopup" type="center"> -->
    <!-- <popup ref="imgRemovalPopup" type="center"> -->
    <div class="drowPopB" v-show="isDrowShow">    
      <div class="imgRemovalPopup">
        <div class="imgbox_top">
          <div>请擦拭需要涂抹的区域</div>
          <div style="cursor: pointer;" @click="saveImage()"><i class="el-icon-error"></i></div>
        </div>
        <div class="imgbox_center">
          <div class="apply">
            <span @click="toggleMode('draw')" :class="mode=='draw'?'spancol':''">涂抹</span>
            <span @click="toggleMode('erase')" :class="mode=='erase'?'spancol':''"
                  style="margin-left:10px;">擦拭涂抹</span>
          </div>
          <div class="brush">
            <span>画笔大小</span>
            <div class="slider">
              <el-slider v-model="brushSize"></el-slider>
            </div>
            <div style="width: 20px;">{{ brushSize }}</div>
          </div>
          <div class="brush scoBox">
            <span>比例</span>
             <div class="addBtn" @click="updateScale(0)">
              <img src="../ToolChild/img/jian.svg" alt="">
             </div> <div class="aocText" style="width: 20px;">{{ parseInt(scale*100) }}%</div>
             <div class="addBtn" @click="updateScale(1)">
              <img src="../ToolChild/img/jia.svg" alt="">
             </div>
            <!-- <div class="slider">
              <el-slider :show-tooltip="false" :max="1" :step="0.2" v-model="scale" @change="updateScale"></el-slider>
            </div> -->
          </div>
          <div class="clear_btn" @click="clearCanvas()">
            <div>清空</div>
          </div>
        </div>
        <div class="canvas_region">
          <div class="canvas-wrapper">
            <!-- <canvas ref="canvas1"></canvas> -->
            <img id="imageOrigin" :src="form.iw_url" alt="Image" ref="canvasRecord">
            <canvas ref="canvasDisplay" :width="originWidth" :height="originHeight" id="canMask"></canvas>
          </div>
          <!-- <div class="canvas_box">
            <canvas class="canvas_img" ref="canvasRecord"></canvas>
            <canvas class="canvas_imgs" ref="canvasDisplay"></canvas>
          </div> -->
        </div>
        <div class="complete_btn" @click="saveImage()">
          <div>完成</div>
        </div>
      </div>
    </div>
    <!-- </popup> -->
  </div>
</template>

<script>
import popup from "COMPONENTS/Popup.vue";
import html2canvas from "html2canvas";

export default {
  components: {popup},
  data() {
    return {
      scaleOrgin:0.1,
      imageSrc: null, // 上传图片的 URL
      scale: 0, // 缩放比例
      scaleStep: 0.1, // 每次缩放的增量
      minScale: 0.5, // 最小缩放比例
      maxScale: 3, // 最大缩放比例
      originWidth:0,
      originHeight:0,
      backgroundImageUrl:'',
      changeNum:12,//微调像素
      canvasYesMask:null,//小图画板
      clearMaskShow:false,//小图遮罩层
      isDrowShow:false,
      clearPath:[],//记录清除轨迹
      // 参数
      form: {
        // 上传图片
        // iw_url:'https://picture.gptkong.com/20241207/15578cff6aa482419e85521e0d12c20c6f.png',
        iw_url:'',
        iw_urls:'',
      },
      // 上传图片
      fileApi: FILE_API_SERVER,
      // 画笔大小
      brushSize: 10,
      mode: 'draw', // 'draw' 或 'erase'
      opacity: 50,

      canvasRecord: null, // 保存 canvas 上下文
      canvasDisplay: null, // 保存 canvas 上下文

      maskCtx: null, // 保存 canvas 上下文
      ///
      isDrawing: false, // 是否正在涂抹
      drawnPathnum: -1, // 存储涂抹次数
      drawnPath: [], // 存储涂抹的路径
      upImgloading:false,
    }
  },
  computed: {},
  created() {

  },
  methods: {
    scaleChange(val){
      console.log('执行');
      
      console.log(val);
      // setTimeout(() => {        
        if(this.scale<val){
          this.updateScale(0)
        }else{
          this.updateScale(1)
        }
      // },500);
    },
    updateScale(data){
      const maxScale = 3; // 最大缩放比例
      const minScale = 0.2; // 最小缩放比例
      if(data){//放大
        if (this.scale < maxScale) {
          this.scale += 0.2; // 每次缩放的增量
          if(this.scale>=3){
            this.scale = 3
          }
        }
      }else{//缩小\
        if (this.scale > minScale) {
          this.scale -= 0.2; // 最小缩放比例
        }
      }
      const imgOr = document.getElementById('imageOrigin');
      const canOr = document.getElementById('canMask');
      imgOr.style.transform = `scale(${this.scale})`;
      canOr.style.transform = `scale(${this.scale})`
    },

    loadMask(fil){
      console.log(fil);
      
    },
    // 上传图片
    handleAvatarSuccess(res,) {
      this.upImgloading = false
      if(res.data.error !== ''){
        this.$message.error(res.data.error);
        return
      }
      this.form.iw_url = res.data.file_full_url;
      this.form.iw_urls = ''
      this.openRemoval()
      this.drawnPath = []
      // setTimeout(() => {
      //   this.getMask()
      // });
    },
    beforeAvatarUpload(file) {
      let _this = this
      const isLt3M = file.size / 1024 / 1024 < 5;
      const isValidType = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const { width, height } = img;
          const isValidResolution =  width <=  4096 &&  height <= 4096;
          this.originHeight = height
          this.originWidth = width

          if (!isValidType) {
            this.$message.error('只能上传 JPG/JPEG/PNG/BMP/WEBP 格式的文件!');
            reject({ isValidType: false });
            return
          }

          if (!isLt3M) {
            this.$message.error('上传文件大小不能超过 5MB!');
            reject({ isLt3M: false });
            return
          }

          if (!isValidResolution) {
            this.$message.error('图片分辨率需小于 4096x4096 像素!');
            reject({ isValidResolution: false });
            return
          }
          this.upImgloading = true
          resolve({ isValidType, isLt3M, isValidResolution, });
        };
        img.onerror = () => {
          this.$message.error('无法读取图片分辨率，请检查图片是否损坏！');
          reject({ isImageValid: false });
        };
      });


    },
    openRemoval() {
      // 打开弹窗
      // this.$refs.imgRemovalPopup.show()
      this.isDrowShow = true
      this.$nextTick(() => {
        // this.loadImage()
        this.drawImage()
      });
    },
    openRemovalOther(){
      this.isDrowShow = true
    },
    closeRemoval() {
      // 关闭弹窗
      // this.$refs.imgRemovalPopup.close()
      this.isDrowShow = false
      // this.saveImage()
    },
    clearCanvas() {
      // 清除整个画布
      const canvas = this.$refs.canvasRecord;
      const canvas2 = this.$refs.canvasDisplay;
      // const canvas3 = this.$refs.yesMask
      // this.canvasRecord.clearRect(0, 0, canvas.width, canvas.height);
      this.canvasDisplay.clearRect(0, 0, canvas.width, canvas.height);
      // this.canvasYesMask.clearRect(0, 0, canvas3.width, canvas3.height);
      this.drawnPath = []
      // this.loadImage()
      this.drawImage()
      this.mode = 'draw'
    },
    loadImage() {

      const canvas = this.$refs.canvasRecord;
      const canvas2 = this.$refs.canvasDisplay;
      // const canvasyse = this.$refs.yesMask;

      if (canvas.getContext) {
        // 获取绘图上下文
        this.canvasRecord = canvas.getContext('2d');
        this.canvasDisplay = canvas2.getContext('2d');
        // this.canvasYesMask = canvasyse.getContext('2d');

      } else {
        // console.log('您的浏览器不支持 canvas')
      }

      const img = new Image();
      img.src = this.form.iw_url
      // this.backgroundImageUrl = this.form.iw_url
      img.onload = () => {
        // 设置 Canvas 的宽度和高度与图片相同
        // this.setImgBili(canvas,600,img)
        // this.setImgBili(canvasyse,140,img)

        // 将图片绘制到 Canvas 上
        this.canvasRecord.drawImage(img, 0, 0, canvas.width, canvas.height);

        // 设置上面的画布为透明
        // this.canvasDisplay.fillRect(0, 0, canvas.width, canvas.height);
        // this.setImgBili(canvas2,600,img)
        if (img.width > maxDimension || img.height > maxDimension) {
          const widthScale = maxDimension / img.width;
          const heightScale = maxDimension / img.height;
          scale = Math.min(widthScale, heightScale);
        } else {
          scale = 1; // 如果图片尺寸小于限制，则保持原始大小
        }
        canvas.style.transform = `scale(${scale})`;
        canvas.style.transform = `scale(${scale})`;
        this.enableDrawing();
        this.brushSize = 15
        
      };
    },
    drawImage() {
      const imgOr = document.getElementById('imageOrigin');
      const canOr = document.getElementById('canMask');
      const naturalWidth = this.originWidth;
      const naturalHeight = this.originHeight;
      const maxDimension = 600; // 最大宽高限制
      const canvas2 = this.$refs.canvasDisplay
      this.canvasDisplay = canvas2.getContext('2d');
      this.scale = 1; // 初始缩放比例
      if (naturalWidth > maxDimension || naturalHeight > maxDimension) {
        const widthScale = maxDimension / naturalWidth;
        const heightScale = maxDimension / naturalHeight;
        this.scale = Math.min(widthScale, heightScale);
        // scale = Math.max(widthScale, heightScale);
      } else {
        this.scale = 1; // 如果图片尺寸小于限制，则保持原始大小
      }
      imgOr.style.transform = `scale(${this.scale})`;
      canOr.style.transform = `scale(${this.scale})`

      this.enableDrawing();
      this.brushSize = 15
      },
    //设置最大宽高比例
    setImgBili(obj,num,img){
      obj.width = img.width > num ? num : img.width;
      obj.height = img.height > num ? (num / img.height) * img.height : img.height;
    },
    enableDrawing(ctx) {
      let _this = this
      let isDrawing = false;
      const canvas2 = this.$refs.canvasDisplay;
      // const canvasYes = this.$refs.yesMask;
      this.canvasDisplay = canvas2.getContext('2d');
      // this.canvasYesMask = canvasYes.getContext('2d')
      // 鼠标画板按下
      canvas2.addEventListener('mousedown', (e) => {
        
        
        isDrawing = true;
        this.canvasDisplay.beginPath();
        // this.canvasYesMask.beginPath();
        this.canvasDisplay.moveTo(e.offsetX, e.offsetY);
        // this.canvasYesMask.moveTo(e.offsetX, e.offsetY);
        console.log(e.offsetX,e.offsetY);
        
      });

      // 鼠标画板移动
      canvas2.addEventListener('mousemove', (e) => {
        if (isDrawing) {

        }
        if (isDrawing == true && this.mode !== 'erase') {
          this.drawnPath.push({x:e.offsetX,y:e.offsetY})
          _this.drawCircle(_this.canvasDisplay, e.offsetX, e.offsetY,'rgba(0, 255, 0, 0.5)');
          // _this.drawCircle(_this.canvasYesMask, e.offsetX, e.offsetY,'rgba(0, 255, 0, 0.5)',canvas2.width,canvas2.height);
        }
        // console.log('mousemove')
        if (this.mode == 'erase' && isDrawing) {
          let qingx = e.offsetX
          let qingy = e.offsetY
          _this.clearPath.push({x:e.offsetX,y:e.offsetY})
          _this.erase(_this.canvasDisplay,qingx,qingy)
          // _this.erase(_this.canvasYesMask,qingx,qingy,canvas2.width,canvas2.height)


          // this.canvasRecord.clearRect(e.offsetX - this.brushSize / 2, e.offsetY - this.brushSize / 2, this.brushSize, this.brushSize)
        }
      });
      // 鼠标画板松开
      canvas2.addEventListener('mouseup', () => {
        isDrawing = false;
        // console.log('mouseup')
        // 在下面的画板上操作
        // this.drawPathOnResult(this.canvasYesMask,canvas2.width,canvas2.height)
      });
      // 鼠标画板离开
      canvas2.addEventListener('mouseout', () => {
        isDrawing = false;
        // console.log('mouseout')

      });
    },
    drawPathOnResult(ctx,w,h) {
      const largeWidth = w;
      const largeHeight = h;
      const smallWidth = this.$refs.originImg.width;
      const smallHeight = this.$refs.originImg.height;

      // 计算缩放比例
      const scaleX = smallWidth / largeWidth;
      const scaleY = smallHeight / largeHeight;
      ctx.beginPath();
      this.drawnPath.forEach((point) => {
        this.canvasYesMask.arc(point.x, point.y*scaleY+2, this.brushSize, 0, Math.PI * 2);
      });
      ctx.fillStyle = 'rgba(0, 255, 0, 0.5)'; // 绿色半透明
      ctx.fill()
      ctx.closePath();
    },
    // 绘制和清除
    toggleMode(name) {
      this.mode = name;
      name === 'erase' ? this.opacity = 1 : this.opacity = 10
    },
    // 涂写笔刷
    drawCircle(ctx, x, y,col='rgba(0, 255, 0, 0.5)',w,h) {
      ctx.globalCompositeOperation = 'source-over'
      this.canvasDisplay.beginPath();
      this.canvasDisplay.arc(x, y, this.brushSize, 0, Math.PI * 2); // 绘制一个半径为 10 的圆形
      this.canvasDisplay.fillStyle = col; // 绿色半透明
      this.canvasDisplay.fill();
      this.canvasDisplay.closePath();
      

      // if(w&&y){
      //   const largeWidth = w;
      //   const largeHeight = h;
      //   const smallWidth = this.$refs.originImg.width;
      //   const smallHeight = this.$refs.originImg.height;

      //   // 计算缩放比例
      //   const scaleX = smallWidth / largeWidth;
      //   const scaleY = smallHeight / largeHeight;
      //   //小画板绘画
      //   this.canvasYesMask.beginPath();
      //   this.canvasYesMask.arc(x, y*scaleY+this.changeNum, this.brushSize, 0, Math.PI * 2); // 绘制一个半径为 10 的圆形
      //   this.canvasYesMask.fillStyle = col; // 绿色半透明
      //   this.canvasYesMask.fill();
      //   this.canvasYesMask.closePath();
      // }

    },
    // 清除笔刷
    erase(ctx, x, y,w,h) {
      const brushSize = this.brushSize;
      ctx.globalCompositeOperation = 'destination-out'; // 设置擦拭模式
      ctx.beginPath();
      ctx.arc(x, y, brushSize, 0, Math.PI * 2); // 绘制一个圆形
      ctx.fill(); // 填充圆形，实现擦拭效果
      this.clearRea(x,y)
      // ctx.globalCompositeOperation = 'source-over'; // 恢复默认模式
      if(w&&h){
        const largeWidth = w;
        const largeHeight = h;
        const smallWidth = this.$refs.originImg.width;
        const smallHeight = this.$refs.originImg.height;
   
        // 计算缩放比例
        const scaleX = smallWidth / largeWidth;
        const scaleY = smallHeight / largeHeight;
        const brushSize = this.brushSize;
        ctx.globalCompositeOperation = 'destination-out'; // 设置擦拭模式
        ctx.beginPath();
        ctx.arc(x, y*scaleY+this.changeNum, brushSize, 0, Math.PI * 2); // 绘制一个圆形
        ctx.fill(); // 填充圆形，实现擦拭效果
        // this.clearRea(x,y)
      }
    },
    clearRea(x,y){
      let r = this.brushSize
      this.drawnPath.forEach((item,index)=>{
        if((item.x >= x-r&&item.x<=x+r)&&(item.y>=y-r&&item.y<=y+r)){
          this.drawnPath.splice(index,1)
        }
      })
    },
    saveImage() {
      let _this = this
      // 获取canvas元素
      // var canvas = this.$refs.canvasDisplay;
      // var ctx = canvas.getContext('2d');
  
      // // 获取要绘制的元素
      // var element = document.querySelector('.canvas_box');
      // // 使用html2canvas将元素转换为画布
      // html2canvas(element,{width:_this.originWidth, height:_this.originHeight}).then(function(canvasElement) {
      //   // console.log(canvasElement);
      //   canvasElement.toBlob(blob => {
      //     const file = new File([blob], 'test.png', { type: 'image/png' })
      //     const formData = new FormData();
      //     formData.append('file', file,);
      //     _this.$http.post(_this.fileApi+'/api/front/upload/?fdir=mj_tool',formData).then(res=>{
      //       _this.form.iw_urls = res.data.file_full_url
      //       _this.clearMaskShow = true
      //       _this.closeRemoval()
            
      //     })
      //   })
          
          

      // }).catch(function(error) {
      //     console.error('Error converting element to canvas:', error);
      // });
      // // console.log('saveImage')
      // const canOr = document.getElementById('canMask');
      // canOr.style.transform = 'scale(1)'
      // this.$forceUpdate()

      setTimeout(() => {        
        const canvas = this.$refs.canvasDisplay;      
        // this.canvasYesMask = canvas.getContext('2d');
        // this.drawPathOnResult(this.canvasYesMask)
        // 获取mask
        canvas.toBlob((blob) => {
          // console.log(blob);
          const file = new File([blob], 'my-drawing.png', { type: 'image/png' })
          const formData = new FormData();
          formData.append('file', file,);
          // this.$refs.elUpload.submit([file])
          _this.$http.post(_this.fileApi+'/api/front/upload/?fdir=mj_tool',formData).then(res=>{
            _this.form.iw_urls = res.data.file_full_url
            // _this.closeRemoval()
            _this.isDrowShow = false
            _this.clearMaskShow = true
            
          })
        })
      });
      // // this.getMask()
      // // // // 关闭弹窗

    },
    // 获取mask
    getMask() {
      // console.log('getMask')
      const canvas = this.$refs.canvasDisplay;
      let mask = this.canvasDisplay.getImageData(0,0,canvas.width,canvas.height)
      // console.log(mask);

      //设置form值
      this.form.mask = mask
      

      // const ctx = canvas.getContext('2d');

      // // 创建一个新的 canvas 用于生成 mask
      // const maskCanvas = document.createElement('canvas');
      // maskCanvas.width = canvas.width;
      // maskCanvas.height = canvas.height;
      // const maskCtx = maskCanvas.getContext('2d');

      // // 将绘制的内容复制到 maskCanvas
      // maskCtx.drawImage(canvas, 0, 0);

      // // 获取 maskCanvas 的像素数据
      // const imageData = maskCtx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
      // const data = imageData.data;

      // // 创建一个二进制掩码数组
      // const mask = new Array(maskCanvas.width * maskCanvas.height).fill(0);

      // for (let i = 0; i < data.length; i += 4) {
      //   const alpha = data[i + 3]; // 获取 alpha 通道值
      //   const x = (i / 4) % maskCanvas.width;
      //   const y = Math.floor(i / 4 / maskCanvas.width);
      //   const index = y * maskCanvas.width + x;
      //   if (alpha > 0) {
      //     mask[index] = 1;
      //   }
      // }
    },


  },
  watch: {}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.needSubImg{
  position: fixed;
  top: 0;
  left: 0;
}
.drowPopB{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  background: rgba(0,0,0,0.6);
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
}
@keyframes scale-breathe {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}


.mj_page {
  width: 100%;
  height: 100%;
  background: #2b2d31;
  border-radius: 10px;
  display: flex;
  //align-items: center;
  //justify-content: center;
}

.left_area {
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .createButton {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0;
    border-top: 1px solid #36373d;

    div {
      font-size: 16px;
      cursor: pointer;
      background-color: #5865f2;
      color: #fff;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 30px;

      span {
        font-size: 12px;
      }
    }
  }

  .left_top {

    height: calc(100% - 76px);
    //overflow-y: auto;
    .goBack {
      margin: 5px 0 15px 0;
      font-size: 14px;
      color: #fff;
      display: flex;

      .iconFont {
        display: flex;
        margin-right: 20px;

        div {
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
          width: 16px;
          margin-right: 5px;

          img {
            width: 100%;
            //height: 100%;
            vertical-align: top;
            opacity: 1;
          }
        }
      }

      .font_title {
        font-weight: 700;
      }

    }
  }

  .left_nav {
    padding: 4px 0;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #36373d;
    display: flex;
    align-items: center;

    color: #fff;

    div {
      flex: 1;
      text-align: center;
      margin: 0 4px;
      cursor: pointer;
    }

    .navSelected {
      background-color: #5865f2;
      border-radius: 4px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }

  .scrollable-content {
    overflow-y: auto;
    height: calc(100% - 120px);
    margin: 10px 0;
    color: #fff;

    .toolsIntroduce {
      background-color: #1e1f22;
      padding: 16px 14px;
      display: flex;
      border-radius: 5px;

      .left {
        margin-right: 12px;
        width: 20px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .right {
        flex: 1;


        div {
          font-size: 14px;
          font-weight: 700;
          height: 20px;
          margin-bottom: 5px;
        }

        span {
          font-size: 12px;
          line-height: 20px;
        }

      }
    }

    .describe {
      .refer_title {
        height: 18px;
        margin: 15px 0;
        display: flex;
        align-items: center;
        font-size: 14px;

        div {
          height: 100%;
          border: 2px solid #5865f2;
          border-radius: 2px;
          margin-right: 5px;
        }
      }

      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;

        .upload-demo {
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 280px;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;
          .yesUploadMask{
            width: 140px;
            height: 140px;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            background: transparent;
          }

          .yesUpload_img {
            width: 140px;
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #FFF;
            font-size: 13px;
            background-color: #5865f2;
            padding: 3px 5px;
            border-radius: 5px;

          }

        }
      }


    }
  }
}

.imgRemovalPopup {
  // width: 800px;
  margin-top: 40px;
  padding: 20px 15px;
  //background-color: #000000;
  background-color: rgb(30,31,34);
  border-radius: 10px;
  //height: 500px;
  font-size: 14px;
  color: #fafafa;

  .imgbox_top {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 700;
  }

  .imgbox_center {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;

    .apply {
      display: flex;

      span {
        display: block;
        width: 100px;
        padding: 8px 0;
        text-align: center;
        background-color: #31374a;
        border-radius: 5px;
        border: 2px solid #31374a;
        cursor: pointer;
      }

      .spancol {
        border: 2px solid #04c066;
      }
    }

    .brush {
      display: flex;
      align-items: center;
      position: relative;
      // .aocText{
      //   position: absolute;
      //   top: -5px;
      //   left: 50%;
      //   transform: translateX(-50%);
      // }
      .addBtn{
        width: 20px;
        height: 20px;
        cursor: pointer;
        img{
          width: 100%;
          height: 100%;
        }
      }

      .slider {
        width: 100px;
        margin: 0 10px;
      }
    }
    .scoBox{
      display: flex;
      justify-content: space-between;
      width: 130px;
    }
    .scoleBox{
      display: flex;
      align-items: center;
      .scoText{
        margin-right: 10px;
      }
      .scoBtn{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #fff;
        background: #919090;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    .clear_btn {
      div {
        padding: 8px 20px;
        margin: 0 20px 0 0;
        text-align: center;
        background-color: #31374a;
        border-radius: 5px;
        border: 2px solid #31374a;
        cursor: pointer;
      }
    }

  }

  .canvas_region {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    background: rgb(20,24,36);
    .canvas-wrapper {
      position: relative;
      width: 600px;
      height: 600px;
      overflow: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      // background-color: #f0f0f0; /* 可选的背景色 */
      // flex-direction: column;
      font-size: 0 !important;
      &::-webkit-scrollbar {
          width: 10px; /* 设置滚动条宽度 */
          height: 10px; /* 设置滚动条高度，对于水平滚动条有效 */
      }
    }
    #imageOrigin{
      position: absolute;
      transform-origin: center; /* 设置缩放中心 */
      transform: scale(1); /* 初始缩放比例 */
      transition: transform 0.3s ease; /* 动画效果 */
      max-width:none !important;
    }

    #canMask {
      position: absolute;
      transform-origin: center;
      transform: scale(1); /* 初始缩放比例 */
      transition: transform 0.3s ease;
    }

    .canvas_box {
      position: relative;
      font-size: 0 !important;
      width: 600px;
      height: 600px;
      /* overflow: hidden; */
      display: flex;
      justify-content: center;
      align-items: center;

      .canvas_img {
        max-width: 600px;
        height: 100%;

      }

      .canvas_imgs {
        max-width: 600px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        //border: 1px solid #000;
        // background: transparent;
        background-size: cover; /* 使背景图像覆盖整个canvas */
  background-position: center; /* 将背景图像居中 */
  background-repeat: no-repeat; /* 防止背景图像重复 */
      }
    }

  }

  .complete_btn {
    padding: 10px 0;
    border-top: 1px solid #353639;

    div {
      margin: 0 auto;
      cursor: pointer;
      background-color: #5865f2;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      white-space: nowrap;
      user-select: none;
      height: 36px;
      width: 250px;
      border-radius: 4px;
    }
  }
}

.fz13 {
  font-size: 13px;
}

.c-fff {
  color: #fff;
}


.con {
  width: 410px;
  height: 560px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;


    .avatar {
      flex-direction: column;
      cursor: pointer;

      .pic {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-bottom: 5px;
        margin-top: 5px;
      }

      .text {
        font-size: 14px;
        color: #fff;

        img {
          width: 14px;
          height: 14px;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .info_list {
      padding: 15px 18px;

      .info_list_title {
        font-size: 14px;
        color: #fff;
        margin-left: -16px;
      }

      .info_item {
        padding: 15px 0;
        border-bottom: 1px solid #36373d;

        .title {
          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          p {
            font-size: 14px;
            color: #b0b0b0;
          }
        }

        .text {
          font-size: 14px;
          color: #b0b0b0;

          .btn {
            padding: 0 14px;
            display: block;
            line-height: 34px;
            cursor: pointer;
            background-color: #5865f2;
            color: #fff;
            border-radius: 4px;

            &:hover {
              background-color: rgba(88, 101, 242, 0.867);
            }
          }
        }
      }
    }
  }
}


.create_error {
  width: 190px;
  height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    line-height: 64px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.defeat_popup {
  width: 600px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}


.Image_manipulation {
  //width: 500px;
  background-color: #3f3c3a;
  padding: 20px 20px;
  border-radius: 4px;
  position: relative;

  .clear {
    position: absolute;
    top: 0;
    right: 0;
    //background-color: #5865f2;
    border: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-icon-error {
      font-size: 20px;
      color: #565658;
    }
  }

  .clear:hover {
    background-color: #343538;
  }
}


.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

</style>